module.exports = __webpack_public_path__ + "static/media/BOPEN-BNB.22254762.svg";